import { render, staticRenderFns } from "./LoadingAuralization.vue?vue&type=template&id=937ddda2&scoped=true&"
var script = {}
import style0 from "./LoadingAuralization.vue?vue&type=style&index=0&id=937ddda2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937ddda2",
  null
  
)

export default component.exports